module.exports = __webpack_public_path__ + "media/img/event/Scholarships2u_live-chat-2-60164ce416d1ef797cf60158ba41d31d.svg";